import { baseApi } from '@app/store/index.api';

import { IDashboardResponse, IDashboardCurrenciesResponse } from '../model/types';

const dashboardApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    dashboard: builder.query<IDashboardResponse, string>({
      query: query => {
        return {
          url: `/dashboard/dashboard?${query}`,
        };
      },
    }),
    dashboardNew: builder.query<IDashboardResponse, string>({
      query: query => {
        return {
          url: `/dashboard/dashboard/new?${query}`,
        };
      },
    }),
    dashboardCurrencies: builder.query<IDashboardCurrenciesResponse, string>({
      query: query => {
        return {
          url: `/dashboard/currencies?${query}`,
        };
      },
    }),
  }),
});

export const { useLazyDashboardQuery, useLazyDashboardNewQuery, useDashboardCurrenciesQuery } =
  dashboardApi;
